<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div *ngIf="accessDeniedService.isOpen" [ngClass]="{ active: accessDeniedService.isOpen }" class="slide-down-modal access-denied-modal">
    <div *ngIf="!accessDeniedService.message" class="alert alert-danger" role="alert">
        <strong>Access is denied!</strong>
    </div>

    <div *ngIf="accessDeniedService.message" class="alert alert-danger" role="alert">
        {{ 'error.' + accessDeniedService.message | translate }}
    </div>
</div>
